import type { ArticlesPro } from '../types';

export const ARTICLES_PRO: ArticlesPro = {
  "p": [
    {
      "article": "https://www.aaaep.fr/aaaep/aaaep-organisme-de-formation-professionnel.html",
      "titre": "Test Psychotechnique Professionnel et formation"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/agent-territorial-publique-collectivite-test-psychotechnique.html",
      "titre": "Tests psychotechniques et conducteurs de la fonction publique"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/agent-territorial-publique-collectivite-test-psychotechnique.html",
      "titre": "Tests psychotechniques pour les professionnels du privé"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-professionnel-conducteur-train-ratp-sncf.html",
      "titre": "Tests Psychotechniques pour les conducteurs de trains"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-police-asvp.html",
      "titre": "Test psychotechnique Police Municipale et ASVP"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/renouvellement-permis-poids-lourd.html",
      "titre": "Renouvellement permis poids lourd"
    }
  ],
  "z": [
    {
      "article": "https://www.aaaep.fr/aaaep/aaaep-organisme-de-formation-professionnel.html",
      "titre": "Test Psychotechnique Professionnel et formation"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/agent-territorial-publique-collectivite-test-psychotechnique.html",
      "titre": "Tests psychotechniques et conducteurs de la fonction publique"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/agent-territorial-publique-collectivite-test-psychotechnique.html",
      "titre": "Tests psychotechniques pour les professionnels du privé"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-professionnel-conducteur-train-ratp-sncf.html",
      "titre": "Tests Psychotechniques pour les conducteurs de trains"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/test-psychotechnique-police-asvp.html",
      "titre": "Test psychotechnique Police Municipale et ASVP"
    },
    {
      "article": "https://www.aaaep.fr/aaaep/renouvellement-permis-poids-lourd.html",
      "titre": "Renouvellement permis poids lourd"
    }
  ]
};
